import { render, staticRenderFns } from "./BaseAnnouncementForm.vue?vue&type=template&id=24398df6&scoped=true&"
import script from "./BaseAnnouncementForm.vue?vue&type=script&lang=js&"
export * from "./BaseAnnouncementForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BaseAnnouncementForm.vue?vue&type=style&index=1&id=24398df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24398df6",
  null
  
)

export default component.exports